<template>
  <div>
    <el-row class="deskContainer">
      <el-col class="clientInfoContainer" :span="24">
        <div class="clientIcon">
          <i class="fa fa-user" aria-hidden="true"></i>
        </div>
        <div class="clientInfo">
          <p class="value-style">
            {{ customer.full_name | applyDecodeRSA}}</p>
          <h3 class="key-style">Nombre cliente</h3>
          <p class="value-style">{{ customer.phone | applyDecodeRSA}}</p>
          <h3 class="key-style">Contacto cliente</h3>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import { decodeRSA } from '../../mixins/function';

export default {
  name: 'GeocodeUserDisplay',
  props: {
    customer: Object,
  },
  filters: {
    applyDecodeRSA(data) {
      return decodeRSA(data);
    },
  },
};
</script>

<style lang="scss" scoped>
  .deskContainer {
    width: 100%;
    padding-bottom: 20px;
    //background: $fb-grey-light-97;
    box-sizing: border-box;
  }
  .clientInfoContainer {
    display: flex;
  }
  .clientIcon {
    height: 77px;
    width: 100px;
    background: white;
    border: 1px solid $fb-grey-light-84;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    .fa-user {
      color: $fb-green;
      font-size: 30px;
    }
  }
  .clientInfo {
    border-top: 1px solid $fb-grey-light-84;
    border-right: 1px solid $fb-grey-light-84;
    border-bottom: 1px solid $fb-grey-light-84;
    padding: 10px;
    width: 100%;
    background: white;
  }
  .key-style {
    font-weight: 700;
    font-size: 8px;
    color: #AAD500;
    margin: 0;
    text-align: left;
    text-transform: uppercase;
    &:first-of-type {
      margin-bottom: 5px;
    }
  }
  .value-style {
    font-weight: 300;
    font-size: 12px;
    margin: 0;
    text-align: left;
  }
</style>
